import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch customers with optional filters
export const getCustomers = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Customer/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

// API to search customers with pagination and search text
export const searchCustomers = async (searchText, page = 1, pageSize = 20) => {
  try {
    console.log('🌐 API Call - searchCustomers:', {
      url: `${BASE_URL}/api/Customer/search`,
      payload: { searchText, page, pageSize, activeOnly: true },
      headers: getAuthHeader()
    });
    
    const response = await axios.post(`${BASE_URL}/api/Customer/search`, {
      searchText: searchText,
      page: page,
      pageSize: pageSize,
      activeOnly: true
    }, {
      headers: getAuthHeader(),
    });
    
    console.log('🌐 API Response - searchCustomers:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error - searchCustomers:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};

// API to insert or update a customer
export const saveCustomer = async (customerData) => {
  try {
    console.log("API call - saveCustomer:", customerData);
    const response = await axios.post(`${BASE_URL}/api/Customer/save`, customerData, {
      headers: getAuthHeader(),
    });
    console.log("API response - saveCustomer:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - saveCustomer:", error);
    throw error;
  }
};

// API to bulk import customers
export const bulkImportCustomers = async (customersData) => {
  try {
    console.log("API call - bulkImportCustomers:", customersData.length, "customers");
    const response = await axios.post(`${BASE_URL}/api/Customer/bulk-import`, customersData, {
      headers: getAuthHeader(),
    });
    console.log("API response - bulkImportCustomers:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - bulkImportCustomers:", error);
    throw error;
  }
};

export const exportCustomersToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Customer/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `CustomerReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting customers:", error);
    throw error;
  }
};
